/**
 * Persisted locale values accepted by the preferences API. Keep this list in
 * sync with shared/user_preference_constants.py on the server.
 */
export const SUPPORTED_UI_LOCALES = [
  'en',
  'en-US',
  'en-GB',
  'en-CA',
  'es',
  'es-MX',
  'fr',
  'fr-CA',
] as const;

export type SupportedUiLocale = (typeof SUPPORTED_UI_LOCALES)[number];

export const TRANSLATION_LANGUAGES = ['en', 'es', 'fr'] as const;

export type TranslationLanguage = (typeof TRANSLATION_LANGUAGES)[number];

export const DEFAULT_UI_LOCALE: SupportedUiLocale = 'en';
export const DEFAULT_RESPONSE_LOCALE: SupportedUiLocale = 'en';

const translationLanguageByLocale: Record<SupportedUiLocale, TranslationLanguage> = {
  en: 'en',
  'en-US': 'en',
  'en-GB': 'en',
  'en-CA': 'en',
  es: 'es',
  'es-MX': 'es',
  fr: 'fr',
  'fr-CA': 'fr',
};

const localeLabelKeyByLocale: Record<SupportedUiLocale, string> = {
  en: 'appLanguage.options.en',
  'en-US': 'appLanguage.options.enUS',
  'en-GB': 'appLanguage.options.enGB',
  'en-CA': 'appLanguage.options.enCA',
  es: 'appLanguage.options.es',
  'es-MX': 'appLanguage.options.esMX',
  fr: 'appLanguage.options.fr',
  'fr-CA': 'appLanguage.options.frCA',
};

export const isSupportedUiLocale = (value: unknown): value is SupportedUiLocale => (
  typeof value === 'string' && SUPPORTED_UI_LOCALES.includes(value as SupportedUiLocale)
);

export const getTranslationLanguage = (
  locale: SupportedUiLocale,
): TranslationLanguage => translationLanguageByLocale[locale];

export const getLocaleLabelKey = (locale: SupportedUiLocale): string => (
  localeLabelKeyByLocale[locale]
);